import { TFunction } from "i18next";
import * as Yup from "yup";

export const sendEmailPatientFormSchema = (t: TFunction) => {
    const emailRegex =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const multipleEmails = (required = false) => {
        let schema = Yup.string()
            .transform((value) => value?.trim() || undefined)
            .test(
                "multiple-emails",
                t("common:form.invalidEmailFormat"),
                (value) => {
                    if (!value) {
                        return !required;
                    }

                    return value
                        .split(";")
                        .map((email) => email.trim())
                        .filter(Boolean)
                        .every((email) => emailRegex.test(email));
                }
            );

        if (required) {
            schema = schema.required(t("common:form.requiredFieldForm"));
        }

        return schema;
    };

    return Yup.object({
        communicationType: Yup.number()
            .required(t("common:form.requiredFieldForm")),
        destinationAddressEmail: multipleEmails(true),
        cc: multipleEmails(),
        bcc: multipleEmails(),
        subject: Yup.string()
            .required(t("common:form.requiredFieldForm")),
        body: Yup.string()
            .required(t("common:form.requiredFieldForm")),
    });
}